import { z } from "zod";
import type { DocumentTypeConfig } from "../types";

export const ProofOfAddressDataSchema = z.object({
  issue_date: z.string(),
  is_proof_of_hosting: z.boolean(),
  formatted_address: z.string(),
});

export type ProofOfAddressData = z.infer<typeof ProofOfAddressDataSchema>;

export const ProofOfAddressExtractionSchema = z.object({
  isValidDocumentType: z.boolean(),
  reason: z.string().optional(),
  issue_date: z.string().nullable(),
  document_holder_name: z.string().nullable(),
  raw_address: z.string().nullable(),
  is_proof_of_hosting: z.boolean().nullable(),
});

export type ProofOfAddressExtraction = z.infer<typeof ProofOfAddressExtractionSchema>;

export const ProofOfAddressContextSchema = z.object({
  talentId: z.guid(),
});

export type ProofOfAddressContext = z.infer<typeof ProofOfAddressContextSchema>;

type ProofOfAddressConfig = DocumentTypeConfig<typeof ProofOfAddressDataSchema, typeof ProofOfAddressContextSchema>;

export const PROOF_OF_ADDRESS_CONFIG: ProofOfAddressConfig = {
  documentType: "proof_of_address",
  documentName: "Justificatif de domicile",
  maxFiles: 5,
  acceptedMimeTypes: ["image/jpeg", "image/png", "application/pdf"],
  dataSchema: ProofOfAddressDataSchema,
  contextSchema: ProofOfAddressContextSchema,
  requiredFields: ["issue_date", "is_proof_of_hosting", "formatted_address"],
  fieldLabels: {
    issue_date: "Date d'émission",
    is_proof_of_hosting: "Attestation d'hébergement",
    formatted_address: "Adresse",
  },
};
